import React from 'react';
import { Link } from 'react-router-dom';
import HelicopterGame from '../components/HelicopterGame';

const GamesPage: React.FC = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Games</h1>
      <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Helicopter Game */}
        <div style={{ border: '1px solid #ccc', borderRadius: 8, padding: '1.5rem', maxWidth: 440, width: '100%', marginBottom: '1.5rem', background: '#181818', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <HelicopterGame />
        </div>
        {/* Category Matcher Game */}
        <div style={{ border: '1px solid #ccc', borderRadius: 8, padding: '1.5rem', maxWidth: 400, width: '100%', marginBottom: '1.5rem', background: '#f9f9f9' }}>
          <h2 style={{ fontSize: 24, marginBottom: 8 }}>📊 Category Matcher</h2>
          <p>Match transactions to their proper categories!</p>
          <Link to="/games/category-matcher">
            <button style={{ padding: '0.75rem 2rem', fontSize: '1rem', borderRadius: 6, background: '#4a90e2', color: '#fff', border: 'none', cursor: 'pointer' }}>
              Play
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GamesPage; 